import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import { Badge } from "@lifepay/rc-ui-toolkit";

import styles from "./ProcessingAccess.m.scss";

const OBJECT_TYPES = {
  bank: "банку",
  branch: "филиалу",
  tid: "терминалам",
  binrange: "картам",
};

const OBJECT_RANGE_TYPE = {
  tid: true,
  binrange: true,
};

function ProcessingAccess(props) {
  const { theme, item } = props;

  const value = OBJECT_RANGE_TYPE[item.objectType]
    ? `c ${item.rangeStart} по ${item.rangeEnd}`
    : `${OBJECT_TYPES[item.objectType] ? "" : "со значением "}${
        item.objectValue
      }`;

  return (
    <div className={classnames(theme.wrapper)}>
      <span className={classnames(theme.description)}>
        {`Доступ к данным по ${OBJECT_TYPES[item.objectType] ||
          `типу ${item.objectType}`} ${value} `}
      </span>
      <Badge
        theme={{ wrapper: theme.state }}
        type={item.hasAccess ? "green" : "red"}
      >
        {item.hasAccess ? "разрешен" : "запрещен"}
      </Badge>
    </div>
  );
}

ProcessingAccess.displayName = "ProcessingAccess";

ProcessingAccess.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
};

ProcessingAccess.defaultProps = {};

export default themr("@lifepay/ProcessingAccess", styles)(ProcessingAccess);



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingAccess/ProcessingAccess.js